import { SxProps } from '@mui/material';

export const iconComponentStylesSx: SxProps = {
	color: '#F96302',
};
